import Select from 'react-select'

/**
 * Dictation languages the Web Speech API recognises well for this audience —
 * Indian English plus the major Indian languages, as BCP-47 codes. The engine
 * listens in ONE language at a time, so this is the switch that sets it.
 */
export const DICTATION_LANGUAGES = [
  { value: 'en-IN', label: 'English' },
  { value: 'hi-IN', label: 'Hindi' },
  { value: 'bn-IN', label: 'Bengali' },
  { value: 'ta-IN', label: 'Tamil' },
  { value: 'te-IN', label: 'Telugu' },
  { value: 'mr-IN', label: 'Marathi' },
  { value: 'gu-IN', label: 'Gujarati' },
]

/* Compact react-select skin tuned for this inline control. Brand gold reads on
 * BOTH the light appointment page and the dark in-call console, so the trigger
 * needs no per-theme variant; the dropdown is a standard white popover (portaled
 * to <body> so the notes card's overflow can't clip it), which sits fine over
 * either background. */
const selectStyles = {
  container: (base) => ({ ...base, width: 122 }),
  control: (base, state) => ({
    ...base,
    minHeight: 32,
    background: 'transparent',
    borderColor: state.isFocused ? 'rgba(200,146,42,.75)' : 'rgba(200,146,42,.4)',
    borderRadius: 9999,
    boxShadow: 'none',
    cursor: 'pointer',
    fontSize: 12,
    ':hover': { borderColor: 'rgba(200,146,42,.6)' },
  }),
  valueContainer: (base) => ({ ...base, padding: '0 2px 0 10px' }),
  singleValue: (base) => ({ ...base, color: '#C8922A' }),
  input: (base) => ({ ...base, color: '#C8922A', margin: 0, padding: 0 }),
  placeholder: (base) => ({ ...base, color: 'rgba(200,146,42,.6)' }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base) => ({ ...base, color: '#C8922A', padding: 4 }),
  menu: (base) => ({ ...base, borderRadius: 12, overflow: 'hidden', width: 150, zIndex: 30 }),
  menuPortal: (base) => ({ ...base, zIndex: 60 }),
  menuList: (base) => ({ ...base, padding: 4 }),
  option: (base, state) => ({
    ...base,
    fontSize: 12.5,
    padding: '8px 12px',
    backgroundColor: state.isSelected ? '#C8922A' : state.isFocused ? 'rgba(200,146,42,.12)' : '#fff',
    color: state.isSelected ? '#fff' : '#1c0a04',
    cursor: 'pointer',
  }),
}

/**
 * The dictation-language switch. Controlled by BCP-47 value; `onChange` gets the
 * next code. Kept intentionally not-searchable — it's a short, fixed list.
 */
export default function LanguageSelect({ value, onChange, disabled = false }) {
  return (
    <Select
      options={DICTATION_LANGUAGES}
      value={DICTATION_LANGUAGES.find((o) => o.value === value) ?? DICTATION_LANGUAGES[0]}
      onChange={(option) => onChange(option?.value ?? 'en-IN')}
      isDisabled={disabled}
      isSearchable={false}
      styles={selectStyles}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
      menuPosition="fixed"
      aria-label="Dictation language"
    />
  )
}
